import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { Box, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './ChipConnector.module.scss';
export const GetChipConnectorTID = (parentTestId)=>getTestIds(parentTestId);
export const ChipConnector = (param)=>{
    let { testId, tone, labels, toggleBiName, onToggle } = param;
    const { ChipConnectorTestIds } = useMemo(()=>GetChipConnectorTID(testId), [
        testId
    ]);
    const label = tone === 'or' ? labels.or : labels.and;
    return /*#__PURE__*/ _jsxs(Box, {
        testId: ChipConnectorTestIds.Root(),
        className: cn(styles.connectorWrapper, {
            [styles.toneOr]: tone === 'or',
            [styles.toneAnd]: tone === 'and'
        }),
        children: [
            /*#__PURE__*/ _jsx(Box, {
                className: styles.hairline
            }),
            onToggle != null ? /*#__PURE__*/ _jsx(TextButton, {
                testId: ChipConnectorTestIds.Toggle(),
                bi: {
                    name: toggleBiName
                },
                onClick: onToggle,
                variant: "paragraph2",
                children: label
            }) : /*#__PURE__*/ _jsx(Typography, {
                testId: ChipConnectorTestIds.Text(),
                variant: "paragraph2",
                className: styles.connectorText,
                children: label
            }),
            /*#__PURE__*/ _jsx(Box, {
                className: styles.hairline
            })
        ]
    });
};
